export default "__VITE_ASSET__0a016134__"